/* eslint-disable max-len */
import React from 'react';
function SwitchAccounts() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M17,15.8V17H7v-1.2c0-2,3.3-2.8,5-2.8S17,13.8,17,15.8z M12,12c1.4,0,2.5-1.1,2.5-2.5S13.4,7,12,7S9.5,8.1,9.5,9.5 S10.6,12,12,12z M16.5,9l3.5,3.5L23.5,9H21V5c0-1.1-0.9-2-2-2H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-5h-2v5H5V5 h14v4H16.5z" })));
}
export default SwitchAccounts;
